import { useCallback, useState } from 'react';

import useSlingApi from '@sdk/api/useSlingApi';
import { useSession } from '@sdk/session/SessionContext';

import config from '../config';

export default function useToastInstall() {
  const [error, setError] = useState('');
  const { integrations } = useSlingApi();
  const { currentUser } = useSession();

  const prepareRedirectUrl = useCallback((baseUrl) => {
    const params = new URLSearchParams(window.location.search);
    // TODO refactor this to URLSearchParams.has() method in sling-sdk
    params.append('entitlements', 'true');
    const returnUrl = new URL(window.location.href);
    params.append('redirect', returnUrl.toString());

    return `${baseUrl}?${params}`;
  }, []);

  const signIn = useCallback(
    () => (window.location.href = prepareRedirectUrl(config.LOGIN_PAGE_URL)),
    [prepareRedirectUrl]
  );
  const signUp = useCallback(
    () => (window.location.href = prepareRedirectUrl(config.SIGNUP_PAGE_URL)),
    [prepareRedirectUrl]
  );

  const configureToast = useCallback(async () => {
    const payload = Object.fromEntries(new URLSearchParams(window.location.search));
    const { data, response } = await integrations.configureToast(payload).catch((e) => e);

    if (response.status === 201) {
      // configure Toast integration and redirect authorized user to integrations page
      const url = new URL(config.INTEGRATIONS_PAGE_URL);
      url.searchParams.append('entitlements', 'true');
      window.location.href = url.toString();
      return;
    }

    const capitalizedMessage = data.message
      ? data.message[0].toUpperCase() + data.message.slice(1).toLowerCase()
      : '';

    setError(capitalizedMessage + (data.errors ? ` (${data.errors.join(', ')})` : ''));
  }, [integrations]);

  const cancel = useCallback(() => (window.location.href = config.TOAST_SLING_CONNECT_URL), []);

  return { currentUser, error, configureToast, cancel, signIn, signUp };
}
